import ManageAccessDialog from './ManageAccessDialog';
export default ManageAccessDialog;
